import { render, staticRenderFns } from "./CreateLayoutContent.vue?vue&type=template&id=43a8a866&scoped=true"
import script from "./CreateLayoutContent.vue?vue&type=script&lang=js"
export * from "./CreateLayoutContent.vue?vue&type=script&lang=js"
import style0 from "./CreateLayoutContent.vue?vue&type=style&index=0&id=43a8a866&prod&scoped=true&lang=css"
import style1 from "./CreateLayoutContent.vue?vue&type=style&index=1&id=43a8a866&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a8a866",
  null
  
)

export default component.exports